import { render, staticRenderFns } from "./seal.vue?vue&type=template&id=0710180e&scoped=true&"
import script from "./seal.vue?vue&type=script&lang=js&"
export * from "./seal.vue?vue&type=script&lang=js&"
import style0 from "./seal.vue?vue&type=style&index=0&id=0710180e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710180e",
  null
  
)

export default component.exports